










import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Footer extends Vue {
  @Prop({
    type: Array,
    required: true,
    default: [
      { label: 'Accueil', path: '#' },
      { label: 'Parents', path: '#' },
      { label: 'École', path: '#' },
      { label: 'Collectivité', path: '#' },
      { label: 'Mentions légales et conditions générales', path: '#' },
      { label: 'Politiques de confidentialité', path: '#' },
      { label: 'Contact', path: '#' },
    ],
  })
  readonly link!: Array<Object>;
}
